<script>
import router from '../../../routes';
import { frontendURL, conversationUrl } from 'dashboard/helper/URLHelper';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    currentChat: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentAccountId: this.currentChat.account_id,
      currentContactId: this.currentChat.meta?.sender?.id,
    };
  },
  computed: {
    previousConversation() {
      if (!this.currentContactId) return null;

      return this.$store.getters[
        'contactConversations/getPreviousConversation'
      ](this.currentContactId, this.currentChat.id);
    },
    nextConversation() {
      if (!this.currentContactId) return null;

      return this.$store.getters['contactConversations/getNextConversation'](
        this.currentContactId,
        this.currentChat.id
      );
    },
  },
  watch: {
    currentChat: {
      handler(newChat) {
        this.currentAccountId = newChat.account_id;
        this.currentContactId = newChat.meta?.sender?.id;
        this.$store.dispatch('contactConversations/get', this.currentContactId);
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.dispatch('contactConversations/get', this.currentContactId);
  },
  methods: {
    showNav() {
      return this.previousConversation || this.nextConversation;
    },
    onOpenConversation(conversationId) {
      const path = frontendURL(
        conversationUrl({
          id: conversationId,
          accountId: this.currentAccountId,
        })
      );
      router.push({ path });
    },
  },
};
</script>

<template>
  <div v-if="showNav" class="flex items-center justify-between py-2">
    <NextButton
      v-tooltip="$t('CONVERSATION.HEADER.PREVIOUS_CONVERSATION')"
      sm
      secondary
      ghost
      icon="i-lucide-chevron-left"
      :disabled="!previousConversation"
      @click="onOpenConversation(previousConversation.id)"
    />
    <NextButton
      v-tooltip="$t('CONVERSATION.HEADER.NEXT_CONVERSATION')"
      sm
      secondary
      ghost
      icon="i-lucide-chevron-right"
      :disabled="!nextConversation"
      @click="onOpenConversation(nextConversation.id)"
    />
  </div>
  <div v-else />
</template>
